import React from "react";
import { useSelector } from "react-redux";
import { object } from "prop-types";
import get from "lodash/get";

import "./live-button.m.css";

const LiveButton = ({ story, isRecommended = false }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const pageType = get(qtState, ["pageType"], null);
  const isLiveBlog = get(story, ["story-template"], "") === "live-blog";
  const isClosed = get(story, ["metadata", "is-closed"], false);
  const liveBtnStyle = pageType === "story-page" && !isRecommended ? "live-button" : "live-button-list-pages";
  return (
    <>
      {isLiveBlog && !isClosed && (
        <div styleName={liveBtnStyle} className="live-button">
          <svg styleName="blinking" width="8" height="8">
            <circle cx="4" cy="4" r="4" fill="#FFFFFF" />
          </svg>
        </div>
      )}
    </>
  );
};

LiveButton.propTypes = {
  story: object,
};

export default LiveButton;
